import * as React from "react";
import { Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

class EvisitTravel extends React.Component {

    render() {
        return (
            <div className="container-fluid body-content evisit-travel-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <h1 className="page-heading">Traveling Outside Texas?</h1>
                        <div className="page-subheading">If you’re traveling outside of Texas, the options below are available.</div>
                        <ul className="angle-bullets">
                            <li><a className="icontextlink" href="https://my.aa.com/onsite-clinics/" target="_blank">Look for an on-site clinic <span className="icon-arrow-sm-rt" /></a></li>
                            <li><a className="icontextlink" href="https://patient.doctorondemand.com/signin/?partner=american" target="_blank">Use Doctor on Demand <span className="icon-arrow-sm-rt" /></a></li>
                            <li><a className="icontextlink" href="https://www.aetna.com/dsepublic/#/contentPage?page=providerSearchLanding&site_id=asa&language=en" target="_blank">Search the Aetna Signature Administrators Network <span className="icon-arrow-sm-rt" /></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }

}

export default EvisitTravel;
